import env from '@/environment';
import { ApiClient } from '@/services/api-client';

export default {
    install (Vue, options) {

        const api = new ApiClient(
            env.apiUrl,
            options.store,
            options.router
        );            

        Vue.api = api;
        Object.defineProperties(Vue.prototype, {
            api: {
                get() { return api; }
            },
            $api: {
                get() { return api; }
            },
        });
    }
};
